import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { PreloaderComponent } from './components/common/preloader/preloader.component';
import { PreloaderService } from './services/preloader.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
    title = 'ringpilot';

    constructor(private preloaderService: PreloaderService) {}

    ngOnInit() {
        // Hide preloader after initialization
        setTimeout(() => {
            this.preloaderService.hide();
        }, 1000);
    }
}